"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // The global data.

exports.data = {}; // The observer of store.

exports.observers = {};